import React, {useEffect, useState} from "react"
import Layout from "../components/layout"
// import { StaticImage } from "gatsby-plugin-image" 
import Tabs from '../components/tabs'
import axios from 'axios'
import dayjs from 'dayjs'
import _ from 'lodash'

require('dayjs/locale/fr');
dayjs.locale('fr')


// markup
const Informations = () => {
  
  const [others, setOthers] = useState([]);
  const [mediatheque, setMediatheque] = useState([]);
  const [musee, setMusee] = useState([]);
  const [abbaye, setAbbaye] = useState([]);

  const getDataApi = () => {
    const url = "https://api-v3.tourinsoft.com/api/syndications/cdt79.tourinsoft.com/af329cc4-6b15-48cb-b539-ff59a445c1cb?format=json";
    axios.get(url).then(res => {
      setOthers(res?.data?.value);
    });
  }

  useEffect(() => {
    // getMediatheque();
    getDataApi();
  }, []);

  useEffect(() => {

    if(others.length > 0){
      console.log('others is full of data =) ');
      let actuMediatheque = _.filter(others, (item) => item.ADRESSEs[0]?.Adresse1?.includes('Bibliothèque'));
      let actuMusee = _.filter(others, (item) => item.ADRESSEs[0]?.Adresse1?.includes('Musée'));
      let actuAbbaye = _.filter(others, (item) => item.ADRESSEORGANISATEURs[0]?.Raisonsociale?.includes('Office de Tourisme'));

      setMediatheque(filterEvents(actuMediatheque));
      setMusee(filterEvents(actuMusee));
      setAbbaye(filterEvents(actuAbbaye));


    }

  }, [others])

  const actuMediatheque = _.filter(others, (item) => item.ADRESSEs[0]?.Adresse1?.includes('Bibliothèque'));
  const actuMusee = _.filter(others, (item) => item.ADRESSEs[0]?.Adresse1?.includes('Musée'));
  const actuAbbaye = _.filter(others, (item) => item.ADRESSEORGANISATEURs[0]?.Raisonsociale?.includes('Office de Tourisme'));


  // Dupplicate & order all events
  const filterEvents = (datas) => {
    console.log('datas => ',datas.length);
    let newTab = [];

    for(let elem of datas){
      // console.log('dates => ',elem.DATESs)
      if(elem.DATESs.length === 1) {
        // console.log('1 date uniquement')
        let newElem = {...elem};
        newElem.date = [elem.DATESs[0]];
        newElem.datededebut = elem.DATESs[0].Datededebut;
        if(elem.DATESs[0].Datededebut === elem.DATESs[0].Datedefin){
          if(new Date(elem.DATESs[0].Datededebut).getTime() > new Date(Date.now()).getTime()) newTab.push(newElem);
        }else{
          if(new Date(elem.DATESs[0].Datedefin).getTime() > new Date(Date.now()).getTime()) newTab.push(newElem);
        }
      }else {
        // console.log('plusieurs dates : ',elem.DATESs.length)
        for(let theDate of elem.DATESs){
          let newElem2 = {...elem}; 
          newElem2.date = [theDate];
          newElem2.datededebut = theDate.Datededebut;
          if(theDate.Datededebut === theDate.Datedefin){
            if(new Date(theDate.Datededebut).getTime() > new Date(Date.now()).getTime()) newTab.push(newElem2);
          }else{
            if(new Date(theDate.Datedefin).getTime() > new Date(Date.now()).getTime()) newTab.push(newElem2);
          }
          // if(new Date(theDate.Datededebut).getTime() > new Date(Date.now()).getTime()) 
        }
      }
    }

    console.log('new tab => ',newTab);

    // newTab = _.sortBy()
    newTab.sort(function compare(a, b) {
      var dateA = new Date(a.datededebut);
      var dateB = new Date(b.datededebut);
      return dateA - dateB;
    });

    console.log('final => ', newTab);

    return newTab;
  }


  const Ouvertures = (date1, date2) => {
    if(date1 === date2) return `<span className='fluxBox-price'>Le ${dayjs(date1).format('D MMMM YYYY')}</span>`
    else return `<span className='fluxBox-price'>Du ${dayjs(date1).format('D MMMM YYYY')} au ${dayjs(date2).format('D MMMM YYYY')}</span>`
  }

  const getTarifs = (txt, tab) => {
    // TARIFSN1s
    if(txt !== null)return txt;
    else {
      let words = '';

      tab.map((item, index) => {
        if(index > 0) words = `${item.Complementtarif}`
        else words = `${words} ; ${item.Complementtarif}`
      })

    }
  }

  const getDates = (dates) => {
    let txt = '';

    dates.map((item, index) => {
      // console.log('item.Datededebut => ',new Date(item.Datededebut).getTime(), ' date now ',new Date(Date.now()).getTime() );
      if(item.Datededebut === item.Datedefin && new Date(item.Datededebut).getTime() > new Date(Date.now()).getTime()){
        if(index === 0) txt = `${item.Heuredouverture1 !== null ? item.Heuredouverture1.replace(':00', '') : ''} ${item.Heuredefermeture1 !== null ? ` à ${item.Heuredefermeture1.replace(':00', '')}` : ''} - ${Ouvertures(item.Datededebut, item.Datedefin)}`
        else txt = `${txt} <br /> ${item.Heuredouverture1 !== null ? item.Heuredouverture1.replace(':00', '') : ''} ${item.Heuredefermeture1 !== null ? ` à ${item.Heuredefermeture1.replace(':00', '')}` : ''} - ${Ouvertures(item.Datededebut, item.Datedefin)}`
      }else if(item.Datededebut !== item.Datedefin) {
        if(index === 0) txt = `${item.Heuredouverture1 !== null ? item.Heuredouverture1.replace(':00', '') : ''} ${item.Heuredefermeture1 !== null ? ` à ${item.Heuredefermeture1.replace(':00', '')}` : ''} - ${Ouvertures(item.Datededebut, item.Datedefin)}`
        else txt = `${txt} <br /> ${item.Heuredouverture1 !== null ? item.Heuredouverture1.replace(':00', '') : ''} ${item.Heuredefermeture1 !== null ? ` à ${item.Heuredefermeture1.replace(':00', '')}` : ''} - ${Ouvertures(item.Datededebut, item.Datedefin)}`
      }
    })

    return txt;
  }

  const getContacts = (contacts) => {
    let txt = '';

    const formatData = (data) => {
      // console.log('data => ',data);
      if(data.TypedaccesTelecom.ThesCode === 'C1' || data.TypedaccesTelecom.ThesCode === 'C6') return `<a href='tel:${data.CoordonneesTelecom}'>${data.CoordonneesTelecom}</a>`
      if(data.TypedaccesTelecom.ThesCode === 'C4') return `<a href='mailto:${data.CoordonneesTelecom}'>${data.CoordonneesTelecom}</a>`
      if(data.TypedaccesTelecom.ThesCode === 'C5') return `<a target='_blank' href='${data.CoordonneesTelecom}'>${data.CoordonneesTelecom}</a>`
    }

    contacts.map((item, index) => {
      if(index === 0) txt = `${formatData(item)}`;
      else txt = `${txt} <br /> ${formatData(item)}`;
    })
    return txt;
  }

  return (
    <Layout>
      <div className="informations">
       
        <div className="pageTitle">
          <h1>Actualités</h1>
        </div>
        
        <div className="boxContent full">
          
          <Tabs>

            <div>

              {mediatheque && mediatheque.map((item, index) => (
                <div className='fluxBox' key={`others${index}`} >
                  <div className='fluxBox-title' dangerouslySetInnerHTML={{ __html: `${item.SyndicObjectName}` }}  />
                  <div className='fluxBox-desc' dangerouslySetInnerHTML={{ __html: `${item.DESCRIPTIFSs[0]?.Descriptioncommerciale}` }}  />
                  {/* <div className='fluxBox-cat' dangerouslySetInnerHTML={{ __html: `${item.ObjectTypeName}` }}  /> */}
                  
                  <div className="fluxBox-infos">
                    {item.TARIFSDETAIL && <div className='fluxBox-price' dangerouslySetInnerHTML={{ __html: `${item.TARIFSDETAIL}` }} />}

                    <div className='fluxBox-dates'>
                      <div className='fluxBox-price' dangerouslySetInnerHTML={{ __html: `${getDates(item?.date)}` }} />
                    </div>
                    
                    {item.ADRESSEs[0]?.Adresse1 && <div className='fluxBox-add' dangerouslySetInnerHTML={{ __html: `${item.ADRESSEs[0]?.Adresse1 ? item.ADRESSEs[0]?.Adresse1 : ''} <br/> ${item.ADRESSEs[0]?.Adresse2 ? item.ADRESSEs[0]?.Adresse2 + '<br/>' : ''} ${item.ADRESSEs[0]?.CodePostal ? item.ADRESSEs[0]?.CodePostal : ''} - ${item.ADRESSEs[0]?.Commune ? item.ADRESSEs[0]?.Commune : ''}` }} />}
                    
                    <div className='fluxBox-contact' dangerouslySetInnerHTML={{ __html: `${getContacts(item?.MOYENSCOMs)}` }} />

                  </div>
                  {/* <div className='fluxBox-location' dangerouslySetInnerHTML={{ __html: item?.location?.name || null }} /> */}
                  {item?.PHOTOSs[0]?.Photo?.Url && <img src={item.PHOTOSs[0].Photo.Url} />}
                </div>
              ))}
            </div>

            <div>
              {musee && musee.map((item, index) => (
                <div className='fluxBox' key={`others${index}`} >
                  <div className='fluxBox-title' dangerouslySetInnerHTML={{ __html: `${item.SyndicObjectName}` }}  />
                  <div className='fluxBox-desc' dangerouslySetInnerHTML={{ __html: `${item.DESCRIPTIFSs[0]?.Descriptionpouredition}` }}  />
                  {/* <div className='fluxBox-cat' dangerouslySetInnerHTML={{ __html: `${item.ObjectTypeName}` }}  /> */}
                  
                  <div className="fluxBox-infos">
                    {item.TARIFSDETAIL && <div className='fluxBox-price' dangerouslySetInnerHTML={{ __html: `${item.TARIFSDETAIL}` }} />}

                    <div className='fluxBox-dates'>
                      <div className='fluxBox-price' dangerouslySetInnerHTML={{ __html: `${getDates(item?.date)}` }} />
                    </div>
                    
                    {item.ADRESSEs[0]?.Adresse1 && <div className='fluxBox-add' dangerouslySetInnerHTML={{ __html: `${item.ADRESSEs[0]?.Adresse1 ? item.ADRESSEs[0]?.Adresse1 : ''} <br/> ${item.ADRESSEs[0]?.Adresse2 ? item.ADRESSEs[0]?.Adresse2 + '<br/>' : ''} ${item.ADRESSEs[0]?.CodePostal ? item.ADRESSEs[0]?.CodePostal : ''} - ${item.ADRESSEs[0]?.Commune ? item.ADRESSEs[0]?.Commune : ''}` }} />}
                    
                    <div className='fluxBox-contact' dangerouslySetInnerHTML={{ __html: `${getContacts(item?.MOYENSCOMs)}` }} />

                  </div>
                  {/* <div className='fluxBox-location' dangerouslySetInnerHTML={{ __html: item?.location?.name || null }} /> */}
                  {item?.PHOTOSs[0]?.Photo?.Url && <img src={item.PHOTOSs[0].Photo.Url} />}
                </div>
              ))}
            </div>

            <div>
            {abbaye && abbaye.map((item, index) => (
                <div className='fluxBox' key={`others${index}`} >
                  <div className='fluxBox-title' dangerouslySetInnerHTML={{ __html: `${item.SyndicObjectName}` }}  />
                  <div className='fluxBox-desc' dangerouslySetInnerHTML={{ __html: `${item.DESCRIPTIFSs[0]?.Descriptionpouredition}` }}  />
                  {/* <div className='fluxBox-cat' dangerouslySetInnerHTML={{ __html: `${item.ObjectTypeName}` }}  /> */}
                  
                  <div className="fluxBox-infos">
                    {item.TARIFSDETAIL && <div className='fluxBox-price' dangerouslySetInnerHTML={{ __html: `${getTarifs(item.TARIFSDETAIL, item.TARIFSN1s)}` }} />}

                    <div className='fluxBox-dates'>
                      <div className='fluxBox-price' dangerouslySetInnerHTML={{ __html: `${getDates(item?.date)}` }} />
                    </div>
                    
                    {item.ADRESSEs[0]?.Adresse1 && <div className='fluxBox-add' dangerouslySetInnerHTML={{ __html: `${item.ADRESSEs[0]?.Adresse1 ? item.ADRESSEs[0]?.Adresse1 : ''} <br/> ${item.ADRESSEs[0]?.Adresse2 ? item.ADRESSEs[0]?.Adresse2 + '<br/>' : ''} ${item.ADRESSEs[0]?.Adresse3 ? item.ADRESSEs[0]?.Adresse3 + '<br/>' : ''} ${item.ADRESSEs[0]?.CodePostal ? item.ADRESSEs[0]?.CodePostal : ''} - ${item.ADRESSEs[0]?.Commune ? item.ADRESSEs[0]?.Commune : ''}` }} />}

                    <div className='fluxBox-contact' dangerouslySetInnerHTML={{ __html: `${getContacts(item?.MOYENSCOMs)}` }} />
                  </div>
                  {/* <div className='fluxBox-location' dangerouslySetInnerHTML={{ __html: item?.location?.name || null }} /> */}
                  {item?.PHOTOSs[0]?.Photo?.Url && <img src={item.PHOTOSs[0].Photo.Url} />}
                </div>
              ))}

              {actuAbbaye && actuAbbaye.length === 0 && (
                <div>Pas d'actualités pour le moment</div>
              )}
            </div>

          </Tabs>
        </div>

      </div>
    </Layout>
  )
}

export default Informations
